import React from 'react';
import { motion } from 'framer-motion';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { earlierRoles, roles } from '../data/profile';
export function CareerRecord() {
  return <PageShell path="/career" data-id="element-241" data-mp="d3eulwldvgi4">
      <section id="appointments" className="bg-white py-20 lg:py-24" aria-labelledby="appointments-heading" data-id="element-242" data-mp="h6uowm9zd4rn">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-243" data-mp="3gmrmlg4lsblk">
          <div id="appointments-heading" data-id="element-244" data-mp="3gkew2eks4sww">
            <SectionHeading eyebrow="Executive Appointments" title="Track record, in sequence" description="Each appointment listed with the mandate held and what was delivered against it." data-id="element-245" data-mp="3lkjiel8dchv1" />
          </div>

          <ol className="mt-14 border-t border-platinum-200" data-id="element-246" data-mp="2xvqfu5x8rbrg">
            {roles.map((role, index) => <motion.li key={role.organisation} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="border-b border-platinum-200 py-10" data-id="element-247" data-mp="31xbxe4kq0e7z" data-mpi={index}>
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-248" data-mp="1dnj0lujqguph">
                  <div className="lg:col-span-4" data-id="element-249" data-mp="18pzksq7e09vf">
                    <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-250" data-mp="13r64yr4mo6s3">
                      {role.period}
                    </p>
                    <h3 className="mt-4 font-display text-xl font-bold leading-snug tracking-tight text-navy-900 lg:text-2xl" data-id="element-251" data-mp="zs769o9hp693">
                      {role.title}
                    </h3>
                    <p className="mt-2 font-sans text-base font-medium text-charcoal-600" data-id="element-252" data-mp="pthpjytbxruf">
                      {role.organisation}
                    </p>
                    {index === 0 ? <span className="mt-4 inline-flex items-center bg-navy-900 px-2.5 py-1 font-sans text-xs font-semibold uppercase tracking-[0.12em] text-gold-400" data-id="element-253" data-mp="2k6h6bv9g4s3a">
                        Current
                      </span> : null}
                  </div>

                  <div className="lg:col-span-8" data-id="element-254" data-mp="8jnkapwjb2q5">
                    <p className="border-l-2 border-gold-500 pl-5 font-sans text-base leading-relaxed text-charcoal-700" data-id="element-255" data-mp="dh5suf6n3fxm">
                      {role.mandate}
                    </p>
                    <ul className="mt-6 space-y-3.5" data-id="element-256" data-mp="1155jlf3yb6c7">
                      {role.achievements.map(achievement => <li key={achievement} className="flex items-start gap-3.5" data-id="element-257" data-mp="r92f42lmmvm3">
                          <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 bg-gold-600" data-id="element-258" data-mp="w7wyp6rf4o79" />
                          <span className="font-sans text-sm leading-relaxed text-charcoal-700 lg:text-base" data-id="element-259" data-mp="3bz1azdpede8c">
                            {achievement}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </motion.li>)}
          </ol>
        </div>
      </section>

      <section id="earlier" className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="earlier-heading" data-id="element-260" data-mp="1u3shnv4i0qnd">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-261" data-mp="23zm3y680ryic">
          <div id="earlier-heading" data-id="element-262" data-mp="24040z52iagrb">
            <SectionHeading eyebrow="Earlier Leadership" title="Foundational appointments" data-id="element-263" data-mp="1ga1b8vm2dmvv" />
          </div>
          <ul className="mt-10 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 sm:grid-cols-3" data-id="element-264" data-mp="1bb6s1sk6pwb8">
            {earlierRoles.map(role => <li key={role.organisation} className="flex flex-col bg-white p-8" data-id="element-265" data-mp="1p3mq0ey8b45a">
                <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-266" data-mp="1ka1yn5r558f2">
                  {role.period}
                </p>
                <p className="mt-3 font-display text-base font-bold text-navy-900" data-id="element-267" data-mp="skytlnrfju1d">
                  {role.organisation}
                </p>
                <p className="mt-2 font-sans text-sm font-medium text-charcoal-700" data-id="element-268" data-mp="15b98m0ush8ii">{role.title}</p>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-269" data-mp="1a9ane9l6mlo6">
                  {role.context}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}